import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './classes.module.scss';
import Spiner from '../../../common/helpers/spiner';
import AppGeneralPopupOriginal from '../../../common/app_general_popup';
import { appGeneralPopupTheme } from '../../../common/config/const';
import { useAutoRedeemPromoCode } from './hooks/useAutoRedeemPromoCode';

const AppGeneralPopup = AppGeneralPopupOriginal as any;

const { shared } = window as any;

interface AutoRedeemPromoCodeProps {
  setApplicationError: (error: { errorCode?: number; statusText?: string }) => void;
  clearPromoCode: () => void;
  userId?: number;
}

function AutoRedeemPromoCode({ setApplicationError, clearPromoCode, userId }: AutoRedeemPromoCodeProps): React.ReactElement {
  const { t } = useTranslation();
  const { loading, bonusPopup, clearBonusPopup } = useAutoRedeemPromoCode({
    setApplicationError,
    clearPromoCode,
    userId
  });

  return loading ? (
    <div className={ classes.generalLoadingOverlayContainer }>
      <Spiner loaderColor={ shared.appColor } className={ classes.generalLoadingOverlayLoaderContainer } />
    </div>
  ) : (
    <AppGeneralPopup visible={ !!bonusPopup } theme={ appGeneralPopupTheme.CENTERED } closable={ clearBonusPopup }>
      <div className={ classes.autoRedeemPromoCodeBonusPopupContainer }>
        <div className={ classes.autoRedeemPromoCodeBonusPopupHeader }>
          <b>{ bonusPopup?.title || t('app_name_title') }</b>
        </div>
        <div className={ classes.autoRedeemPromoCodeBonusPopupDescription }>
          { bonusPopup?.description }
        </div>
        <div className={ classes.autoRedeemPromoCodeBonusPopupFooter }>
          <button type="button" value="Promo Code" className={ classes.autoRedeemPromoCodeBonusPopupOkButton } onClick={ clearBonusPopup }>
            <b>{ t('promoCode.ok') }</b>
          </button>
        </div>
      </div>
    </AppGeneralPopup>
  );
}

export default AutoRedeemPromoCode;
